import { useEffect } from "react"
import { createPortal } from "react-dom";
import { AlertIcon, CheckCircleIcon, CloseIcon, InfoIcon, XCircleIcon } from "../../../img/svg/adminIcons";

export type AdminToastTone = "success" | "danger" | "warning" | "info";

const tones: { [key in AdminToastTone]: { bar: string, icon: string } } = {
    success: { bar: "bg-emerald-500", icon: "text-emerald-600" },
    danger: { bar: "bg-red-500", icon: "text-red-600" },
    warning: { bar: "bg-amber-400", icon: "text-amber-600" },
    info: { bar: "bg-gray-900", icon: "text-gray-900" },
}

export default function AdminToast({ toast, setToast, tone = "info", message }: { toast: boolean, setToast: (t: boolean) => void, tone?: AdminToastTone, message: string }) {

    useEffect(() => {
        const timeout = setTimeout(() => {
            setToast(false);
        }, 3000)
        return () => clearTimeout(timeout);
        // eslint-disable-next-line
    }, [toast])

    if (!toast) {
        return null;
    }

    const Icon = tone === "success" ? CheckCircleIcon : tone === "danger" ? XCircleIcon : tone === "warning" ? AlertIcon : InfoIcon;

    // portal no body: o toast pode ser renderizado dentro de um modal (que tem transform na animação)
    return createPortal(
        <div role="status" aria-live="polite" className="fixed z-[200] top-3 inset-x-3 md:inset-x-auto md:top-5 md:right-5 md:w-96 font-lato animate-admin-toast motion-reduce:animate-none">
            <div className="relative flex items-center gap-3 overflow-hidden rounded-xl bg-white pl-5 pr-2 py-3 shadow-lg ring-1 ring-gray-900/10">
                <span className={`absolute left-0 inset-y-0 w-1 ${tones[tone].bar}`} />
                <span className={tones[tone].icon}><Icon width="20px" /></span>
                <p className="flex-1 text-sm font-semibold text-gray-900">{message}</p>
                <button type="button" onClick={() => setToast(false)} aria-label="Fechar aviso" className="p-1.5 rounded-lg text-gray-400 hover:text-gray-700 hover:bg-gray-100">
                    <CloseIcon width="16px" />
                </button>
            </div>
        </div>,
        document.body
    )
}
